/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connection_Settings_DescriptionInputs */



/**
* | output |
* | --- |
* | "Saving starts a sync right away. Files that are no longer included are removed from oneAI. Nothing is changed at the source." |
*
* @param {Spaces_Connection_Settings_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connection_settings_description = /** @type {((inputs?: Spaces_Connection_Settings_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connection_Settings_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach dem Speichern startet sofort eine Synchronisierung. Dateien, die nicht mehr enthalten sind, werden aus oneAI entfernt. An der Quelle wird nichts geändert.")
	return /** @type {LocalizedString} */ ("Saving starts a sync right away. Files that are no longer included are removed from oneAI. Nothing is changed at the source.")
});